import Enum from '@square/dashboard-utilities/utils/enum';
import { ProtoBaseModel, attr, repeated } from '@square/dashboard-data/utils/ember-model-stubs';
export const FIELD_TYPE = {
  FILE_TYPE: 'FileType'
};
export const Category = new Enum(['CATEGORY_SUCCESS', 'CATEGORY_INVALID_REQUEST', 'CATEGORY_QUOTA']);
export const Code = new Enum(['SUCCESS', 'MISSING_REQUEST_TOKEN', 'RESOURCE_NOT_FOUND', 'INTERNAL_SERVER_ERROR']);
export const FieldError = ProtoBaseModel.extend({
  detail: attr(String),
  field: attr(String)
});
export default ProtoBaseModel.extend({
  category: attr(Category),
  code: attr(Code),
  detail: attr(String),
  fieldErrors: repeated(FieldError)
});